import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-footer" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("关闭")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.addOrEditDialog,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.addOrEditDialog) = $event)),
    "custom-class": "FormDialogBox",
    width: "600px",
    title: '菜单' + _ctx.addOrEditTypeTitle[_ctx.addOrEditType],
    onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addOrEditCancel()))
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          type: "danger",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addOrEditDialog = false))
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          loading: _ctx.determineBtnLoading,
          type: "primary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addOrEditDetermine()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.addOrEditTypeTitle[_ctx.addOrEditType]), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        class: "addForm",
        model: _ctx.addOrEditForm,
        rules: _ctx.addOrEditRules,
        ref: "addOrEditFormRef",
        "label-width": "auto"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "菜单名称",
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.addOrEditForm.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.addOrEditForm.name) = $event)),
                placeholder: "请输入菜单名称",
                clearable: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}